import { useStyle } from '@/classify';
import { isRequired } from '@/util/formValidators';
import { Form } from 'informed';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import Button from '../Button';
import Field from '../Field';
import TextInput from '../TextInput';
import defaultClasses from './trackOrderForm.module.css';
import { useTrackOrder } from './useTrackOrder';

const TrackOrderForm = props => {
  const classes = useStyle(defaultClasses, props.classes);

  const router = useRouter();

  const afterSubmit = useCallback(
    (email, ordernumber) => {
      // 跳转到订单详情页
      router.push(`/orderstatus?email=${email.trim()}&orderNumber=${ordernumber.replace(/(^\s+|\s+$)|#/g, '')}`);
    },
    [router],
  );

  const talonProps = useTrackOrder({
    afterSubmit,
  });

  const { handleSubmit } = talonProps;

  return (
    <div className={classes.root}>
      <Form
        className={classes.form}
        onSubmit={handleSubmit}
      >
        <Field
          id='orderNumber'
          label={<span className='text-[15px]'>Order Number</span>}
          className={'isRequired'}
          required
        >
          <TextInput
            id='ordernumber'
            autoComplete='ordernumber'
            field='ordernumber'
            validate={isRequired}
          />
        </Field>
        <Field
          id='email'
          label={<span className='text-[15px]'>Billing Zip Code or Email</span>}
          className={'isRequired'}
          required
        >
          <TextInput
            id='email'
            autoComplete='email'
            field='email'
            validate={isRequired}
          />
        </Field>

        <Button
          priority='high'
          className={classes.trackOrderButton}
          type='submit'
        >
          Check
        </Button>
      </Form>
    </div>
  );
};

export default TrackOrderForm;
